import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=ea699f2c&scoped=true&"
import script from "./NavigationFooter.vue?vue&type=script&lang=js&"
export * from "./NavigationFooter.vue?vue&type=script&lang=js&"
import style0 from "./NavigationFooter.vue?vue&type=style&index=0&id=ea699f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea699f2c",
  null
  
)

/* custom blocks */
import block0 from "./NavigationFooter.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "NavigationFooter.vue"
export default component.exports